import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef } from "react";
// material
import { Box } from "@mui/material";

const Page = forwardRef(({ children, title = "", sx = {}, ...other }, ref) => {
  return (
    <Box ref={ref} {...other} sx={{ py: { sm: 4, xs: 3 }, ...sx }}>
      <Helmet>
        <title>{title} | Afritas</title>
      </Helmet>
      {children}
    </Box>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  sx: PropTypes.object,
};

export default Page;
